"use client";

import styles from "./StudentTestimonial.module.scss";
import cn from "clsx";
import SectionCardWithBg from "@/revamp/molecules/SectionCardWithBg";
import ArrowRight from "@/SvgIcons/ArrowRight";
import VideoWrapper from "@/revamp/organisms/VideoWrapper";
import { pushToDataLayer } from "@/helpers/gtag";


const brandData = {
  Title: { text: "Hear what our students have to say", enabled: true },
  SubTitle: { text: "Discover student learning experiences and journeys at Amity Online", enabled: true },
};

export default function StudentTestimonial({ isMobile }: { isMobile: boolean }) {

  const handleGaClick = () => {
    pushToDataLayer({
      cta_text : "FAST TRACK YOUR CAREER",
      page_type : "Home Page",
      page_url : window.location.href || "NA"
    })
  } 
  

  return (
    <section className={cn(styles.testimonialSection,"relative sm:mt-6")}>
      <div className={cn(styles.gradient,styles.darkBottomGradient)}></div>
      <SectionCardWithBg {...brandData} hideHr={true} />
      <div className={styles.testimonialContainer}>
        <VideoWrapper isMobile={isMobile} />
        <div className={styles.cta}>
          <a href="/student-story" onClick={handleGaClick} className={styles.ctaButton}>See Alumni Success Stories 
            <span className={styles.arrowIcon}>
              <ArrowRight color="#fff" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
